import { environment } from '@environments/environment';

export const msalConfig = {
  auth: {
    clientId: environment.azureAd.clientId,
    authority: `${environment.auth.authority}/${environment.azureAd.tenantId}`,
    redirectUri: environment.azureAd.redirectUri,
  },
};

export const protectedResources = {
  erpAPI: {
    endpoint: environment.apiUrl,
    scopes: environment.azureAd.scopes,
  },
};
